import { Component, OnInit, OnDestroy, forwardRef, Input, OnChanges } from '@angular/core';
import { FormBuilder, FormGroup, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { FormControl } from '@angular/forms/src/model';

@Component({
  selector: 'plr-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => SearchComponent), multi: true }
  ]
})
export class SearchComponent implements OnInit, OnDestroy, ControlValueAccessor {
  formGroup: FormGroup;
  searchControl: FormControl;
  subscritpion: Subscription;
  propagateChange: any = () => { };
  touched: any = () => { };

  @Input()
  useMaterial: boolean;

  constructor(private formBuilder: FormBuilder) {
    this.searchControl = this.formBuilder.control('');
    this.formGroup = this.formBuilder.group({
      search: this.searchControl
    });
  }

  ngOnInit(): void {
    this.subscritpion = this.searchControl.valueChanges.subscribe(() => {
      this.propagateChange(this.searchControl.value);
    });
  }

  ngOnDestroy(): void {
    if (this.subscritpion) {
      this.subscritpion.unsubscribe();
    }
  }

  writeValue(obj: any): void {
    this.searchControl.patchValue(obj);
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.touched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.searchControl.disable();
    } else {
      this.searchControl.enable();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/search/components/search.component.ts